





















import { useVModel } from '@vueuse/core';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

import { IUser } from '@/models';

import { VAutocomplete } from 'vuetify/lib/components';
import { useFetchWorkflowFormTemplateRevisionsStakeholderUsers } from '@/composable/workflow-form-template';

export default defineComponent({
  name: 'WorkflowFormTemplateStakeholderUsersAutoCompletePicker',

  props: {
    value: [Array, Number, Object] as PropType<
      IUser | number | (IUser | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    itemText: {
      type: [String, Function] as PropType<
        string | ((user: IUser | number) => string)
      >,
      default: () => (user: IUser | number) => user.toString()
    },

    clearable: {
      type: Boolean,
      default: true
    }
  },

  setup(props) {
    const userVModel = useVModel(props);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const {
      error,
      users,
      isLoading
    } = useFetchWorkflowFormTemplateRevisionsStakeholderUsers();

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      users,
      userVModel,
      isLoading,
      errorMessageList
    };
  }
});
